import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { AppRoutes } from '@/constants/appRoutes'

export const AuthError = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const errorCode = searchParams.get('code') ?? 'AZURE_AUTH_FAILED'
  const errorMessageKey = `auth.errors.${errorCode}`
  const errorMessage = t(errorMessageKey, {
    defaultValue: t('auth.errors.AZURE_AUTH_FAILED'),
  })

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-4 text-center">
      <h1 className="text-2xl font-semibold">{t('auth.errors.title')}</h1>
      <p className="max-w-md text-base text-muted-foreground">{errorMessage}</p>
      <Button onClick={() => navigate(AppRoutes.login)}>
        {t('auth.errors.back_to_login')}
      </Button>
    </div>
  )
}

export default AuthError
